<template>
  <div class="app-container">
    <CrudTable entity="DomainUser" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [{ field: 'code', label: 'login.code' }, 'name', { field: 'domainName', label: 'common.domain' }]
    };
  }
};
</script>

<style scoped></style>
